import api from './base';

export const loginUser = async (credentials) => {
    const res = await api.post('/auth/login', credentials, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
    return res.data;
};